import { FunctionComponent, useState, useCallback } from 'react';
import { createFragmentContainer, graphql, Environment } from 'react-relay/legacy';
import { connect } from 'react-redux';
import classNames from 'classnames';
import SiteNav from '../SiteNav/SiteNav';
import Contact1stdibsLink from '../Contact1stdibsLink/Contact1stdibsLink';

import styles from './BottomBar-style.scss';

import { BottomBar_viewer as ViewerType } from './__generated__/BottomBar_viewer.graphql';

type ReduxStoreType = {
    header: {
        isUserTypeTrade: boolean;
        isNavigationRefreshVariant: boolean;
    };
};

type BottomBarProps = {
    hasUserId: boolean;
    hasRootPendingRefetch: boolean;
    isUserTypeTrade: boolean;
    isNavigationRefreshVariant: boolean;
    viewer: ViewerType;
    userId: string;
    environment: Environment;
};

const BottomBar: FunctionComponent<BottomBarProps> = ({
    hasUserId,
    hasRootPendingRefetch,
    isUserTypeTrade,
    isNavigationRefreshVariant,
    viewer,
}) => {
    const [isNavigationHovered, setIsNavigationHovered] = useState(false);
    const onMouseEnter = useCallback((): void => {
        setIsNavigationHovered(true);
    }, [setIsNavigationHovered]);
    const onMouseLeave = useCallback((): void => {
        setIsNavigationHovered(false);
    }, [setIsNavigationHovered]);

    const barClassName = classNames(styles.bar, {
        [styles.navigationRefreshBar]: isNavigationRefreshVariant,
    });

    return (
        <div className={barClassName}>
            <div className={styles.barContent}>
                <div className={styles.wrapper} data-tn="main-nav-bottom">
                    <SiteNav
                        viewer={viewer}
                        isNavigationHovered={isNavigationHovered}
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                    />
                    <Contact1stdibsLink
                        hasUserId={hasUserId}
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        isUserTypeTrade={isUserTypeTrade}
                        viewer={viewer}
                        isNavigationHovered={isNavigationHovered}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({
    header,
}: ReduxStoreType): {
    isUserTypeTrade: boolean;
    isNavigationRefreshVariant: boolean;
} => {
    const { isUserTypeTrade, isNavigationRefreshVariant } = header;
    return {
        isUserTypeTrade,
        isNavigationRefreshVariant,
    };
};

export default createFragmentContainer(connect(mapStateToProps)(BottomBar), {
    viewer: graphql`
        fragment BottomBar_viewer on Viewer {
            ...SiteNav_viewer
            ...Contact1stdibsLink_viewer
        }
    `,
});
